import { useEffect } from "react";

const BASE = "Prasad Tutor Group (PTG)";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE}` : `${BASE} | Quality Education. Personal Attention. Proven Results.`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
      }
      m.content = description;
    }
  }, [title, description]);
  return null;
}
